import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=56df32ba&scoped=true&"
import script from "./AvatarIcon.vue?vue&type=script&lang=js&"
export * from "./AvatarIcon.vue?vue&type=script&lang=js&"
import style0 from "./AvatarIcon.vue?vue&type=style&index=0&id=56df32ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df32ba",
  null
  
)

export default component.exports